export const iPadAllowDoubleClickCreateShortcutData = {
    'data-allow-double-click-creates': true,
};
